import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { createContext, useContext } from "react";

function createOptionalContext() {
  let initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  const Context = /*#__PURE__*/createContext(initialValue);

  const useOptionalContext = () => useContext(Context);

  const Provider = (_ref) => {
    let {
      children,
      value
    } = _ref;
    return /* @__PURE__ */jsxRuntimeExports.jsx(Context.Provider, {
      value,
      children
    });
  };

  return [Provider, useOptionalContext];
}

export { createOptionalContext };